module.exports = __webpack_public_path__ + "img/browser7.8a35c25f.png";